<template>
  <div class="item">
    <router-link
      :to="$store.getters['main/getSingleUrl'](item)"
      class="title font-21 f-roman underline"
    >
      {{ _.get(item, "title") }}
    </router-link>
    <p class="date font-16 f-roman">{{ $fn.tr("Published:") }} {{ getDate }}</p>
  </div>
</template>

<script>
import moment from "moment";
export default {
  props: {
    item: {
      required: true
    }
  },
  data() {
    return {};
  },
  computed: {
    getDate() {
      return moment(_.get(this.item, "date")).format("D MMM YYYY");
    }
  }
};
</script>
